import { FC } from "react";
import { SecondaryBlockSize, TertiaryBlockSize } from "./block-variant-size";
import { BlockType } from "./block-type";
import { BlockTheme } from "./block-theme";
import {
  HeaderBlockType,
  PrimaryBlockType,
  PrimaryCollectionBlockType,
  SecondaryBlockType,
  TertiaryBlockType,
} from "./block-prop-types";
import {
  PrimaryBlockConfig,
  SecondaryBlockConfig,
  TertiaryBlockConfig,
} from "../blocks";
import {
  FCFooterBlock,
  FCFooterWidgetBlock,
  isFooterBlock,
} from "./footer-blocks";

/**
 * Functional component type definitions for Primary, Secondary and Tertiary blocks
 */
export type FCHeaderBlock<T extends HeaderBlockType> = FCPrimaryBlock<T>;
export type FCPrimaryCollectionBlock<T extends PrimaryCollectionBlockType> =
  FCPrimaryBlock<T>;
export type FCPrimaryBlock<T extends PrimaryBlockType> = {
  secondaryBlockSize: SecondaryBlockSize;
  tertiaryBlockSize: TertiaryBlockSize;
  blockConfig: PrimaryBlockConfig;
  blockType: BlockType;
  blockTheme: BlockTheme;
} & FC<T>;

export type FCSecondaryBlock<T extends SecondaryBlockType> = {
  blockConfig: SecondaryBlockConfig;
  blockSize: SecondaryBlockSize | SecondaryBlockSize[];
  blockType: BlockType;
} & FC<T>;

export type FCTertiaryBlock<T extends TertiaryBlockType> = {
  blockConfig: TertiaryBlockConfig;
  blockSize: TertiaryBlockSize | TertiaryBlockSize[];
  blockType: BlockType;
} & FC<T>;

export type FCKameleonBlock =
  | FCPrimaryCollectionBlock<any>
  | FCPrimaryBlock<any>
  | FCSecondaryBlock<any>
  | FCTertiaryBlock<any>
  | FCFooterBlock<any>
  | FCFooterWidgetBlock<any>;
export const isPrimaryBlock = (f: FCKameleonBlock): f is FCPrimaryBlock<any> =>
  (f as FCPrimaryBlock<any>).secondaryBlockSize !== undefined &&
  (f as FCPrimaryBlock<any>).tertiaryBlockSize !== undefined &&
  !isFooterBlock(f as FCPrimaryBlock<any>);
